/* eslint-disable */
import axios from './axios.js'
import qs from 'qs'
// import Store from '@/store/index.js'
import {
  getStore
} from '@/common/utils.js'

// 如果是线上环境，在调任何接口前，需要先调一个获取token的接口，然后吧token塞到其他接口的header中
const createAPI = (url, method, config, vconfig = {}) => {
  config = config || {}
  if (config.headers) {
    config.headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
      ...config.headers
    }
  }
  // console.log(Store.state.token)
  // let authorization = getStore('authorization')
  // if (authorization) {
  //   config.headers = {
  //     'authorization': 'Bearer ' + authorization,
  //     ...config.headers
  //   }
  // }

  // config.headers ? config.headers = {
  //   'Accept': 'application/json',
  //   'Content-Type': 'application/x-www-form-urlencoded',
  //   ...config.headers
  // } : config.headers = {
  //   'Accept': 'application/json',
  //   'Content-Type': 'application/x-www-form-urlencoded'
  // }
  if (config.headers && config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    config.data = qs.stringify(config.data)
  }
  return axios({
    url,
    method,
    ...config,
    vconfig
  })
}

export default createAPI